import * as Constants from '../modules/constants';

export function authenticate(username, password) {
    // Make request to auth endpoint if this was for real, but it's not :)
    return new Promise((resolve, reject) => {
        fetch(Constants.API_URL + '/v1/users/authenticate', {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ UserName: username, Password: password })
        })
            .then(function (response) {
                if (!response.ok) {
                    var error = new Error(response.statusText);
                    error.response = response;
                    throw error;
                }
                return response.json();
            })
            .then(function (json) {
                resolve({ userId: json.id, userName: json.username, email: json.email, userLocations: json.locations ? json.locations : [], token: json.token });
            })
            .catch(error => reject(error) );
    });
}


// WEBPACK FOOTER //
// ./src/modules/auth.js